import { DashboardTabs, RdarrReimaginedTabs } from '../../../constants/routing/tabs.constants';
import { RdarrRoutingUrls } from '../../../constants/routing/urls.constants';

export const MainDocumentationPagesConfig = [
    {
        id: DashboardTabs.rdarrReimagined,
        title: 'RDARR Overview',
        path: RdarrRoutingUrls.rdarrReimagined,
    },
    {
        id: DashboardTabs.evidenceBasedApproach,
        title: 'RDARR Self-Assessment',
        path: RdarrRoutingUrls.evidenceBasedApproach,
        tooltip: {
            content: {
                body: 'RDARR Self-Assessment is based on the evidence driven approach',
            },
            options: {
                placement: 'bottom',
            },
        },
    },
    // {
    //     id: DashboardTabs.dataQuality,
    //     title: 'Data Quality',
    //     path: RdarrRoutingUrls.dataQuality,
    //     disabled: true,
    // },
    // {
    //     id: DashboardTabs.riskAndFinanceAlignment,
    //     title: 'Risk and Finance Alignment',
    //     path: RdarrRoutingUrls.riskAndFinanceAlignment,
    //     disabled: true,
    // },
    {
        id: DashboardTabs.sarbSelfAssessment,
        title: 'SARB Self-Assessment',
        path: RdarrRoutingUrls.sarbSelfAssessment,
    },
];

export const RdarrReimaginedTabsConfig = [
    {
        id: RdarrReimaginedTabs.rdarrFrameworks,
        title: 'RDARR Frameworks',
    },
    {
        id: RdarrReimaginedTabs.groupCommittees,
        title: 'Group Committees',
    },
    {
        id: RdarrReimaginedTabs.components,
        title: 'Components',
    },
];
